<template>
    <nav class="firstNav">
        <ul @mouseenter="hideSecondMenu" @mouseleave="showSecondMenu">
            <router-link to="/dashboard" style="color: #FFFFFF; text-decoration: none;"><li class="active"><span><font-awesome-icon icon="table" /></span> <span class="text">Dashboard</span></li></router-link>
            <!--<router-link to="/products" style="color: #FFFFFF; text-decoration: none;"><li><span><font-awesome-icon icon="clipboard-list" /></span> Inventory</li></router-link>-->
            <router-link to="/relationships" style="color: #FFFFFF;"><li><span><font-awesome-icon icon="user-friends" /></span> <span class="text">Customers</span></li></router-link>
            <router-link to="/jobs?type=active" style="color: #FFFFFF;"><li><span><font-awesome-icon icon="file-alt" /></span> <span class="text">Jobs</span></li></router-link>
            <router-link to="/assets" style="color: #FFFFFF; text-decoration: none;"><li><span><font-awesome-icon icon="clipboard-list" /></span> Assets</li></router-link>
            <!--<router-link to="/purchase-orders" style="color: #FFFFFF;"><li><span><font-awesome-icon icon="dolly" /></span> Stock Control</li></router-link>
            <li><span><font-awesome-icon icon="chart-bar" /></span> Intelligence</li>-->
            <li><span><font-awesome-icon icon="cogs" /></span> <span class="text">Settings</span></li>
            <li @click="logout" style="cursor: pointer;"><span><font-awesome-icon icon="angle-double-right" /></span> <span class="text">Log out</span></li>
        </ul>
    </nav>
</template>

<script>
import axios from 'axios'
import { clearSession } from '@/auth'

export default {
  methods: {
    logout: function () {
      // Revoke the token on the server, but sign out locally even if that fails.
      axios.post('/api/logout').catch(() => {}).finally(() => {
        clearSession()
        this.$router.push({ name: 'Home' })
      })
    },
    hideSecondMenu: function (e) {
      document.getElementById('leftNavSecond').classList.remove('active')
    },
    showSecondMenu: function (e) {
      document.getElementById('leftNavSecond').classList.add('active')
    }
  }
}
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
/*
export default {
  name: 'Home',
  components: {
    HelloWorld
  }
} */
</script>
